import { render, staticRenderFns } from "./DiscoverBookList.vue?vue&type=template&id=8eeb3444&"
import script from "./DiscoverBookList.vue?vue&type=script&lang=js&"
export * from "./DiscoverBookList.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverBookList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports